import { supabase } from "@/lib/supabaseClient";

type SupabaseUser = {
  id: string;
  email?: string;
  phone?: string;
  user_metadata?: Record<string, any>;
};

function deriveDisplayName(u: SupabaseUser): string {
  return (
    u.user_metadata?.full_name ||
    u.user_metadata?.name ||
    u.user_metadata?.given_name ||
    u.user_metadata?.family_name ||
    "—"
  );
}

function deriveAvatar(u: SupabaseUser): string | null {
  return u.user_metadata?.avatar_url || u.user_metadata?.picture || null;
}

export async function ensureProfile(user: SupabaseUser | null | undefined) {
  if (!user) {
    console.log("[PROFILE] ensureProfile: no user provided");
    return;
  }

  try {
    if (import.meta.env.MODE === "development") {
      console.log("[PROFILE] ensureProfile checking...");
    }
    
    // Tenta obter rápido (menos tráfego se já existe)
    const { data: existing, error: selError } = await supabase
      .from("profile")
      .select("user_id")
      .eq("user_id", user.id)
      .maybeSingle();

    if (selError) {
      console.error("[PROFILE] select error:", selError);
      console.error("[PROFILE] select error details:", JSON.stringify(selError, null, 2));
      throw selError;
    }

    if (existing) {
      if (import.meta.env.MODE === "development") {
        console.log("[PROFILE] ensureProfile: profile already exists");
      }
      return; // já existe
    }

    if (import.meta.env.MODE === "development") {
      console.log("[PROFILE] ensureProfile: creating new profile");
    }
    const payload = {
      user_id: user.id,
      full_name: deriveDisplayName(user),
      email: user.email || null,
      phone: user.phone || null,
      avatar_url: deriveAvatar(user),
      // plan e payment_status usam defaults
    };

    // Insert idempotente (em caso de corrida de dois logins simultâneos)
    const { data: insertData, error: insError } = await supabase
      .from("profile")
      .insert(payload)
      .select();

    if (insError) {
      console.error("[PROFILE] insert error:", insError);
      console.error("[PROFILE] insert error code:", insError.code);
      console.error("[PROFILE] insert error message:", insError.message);
      console.error("[PROFILE] insert error details:", JSON.stringify(insError, null, 2));
      throw insError;
    }
    
    if (import.meta.env.MODE === "development") {
      console.log("[PROFILE] ensureProfile: profile created successfully");
    }
  } catch (err) {
    console.error("[PROFILE] ensureProfile error:", err);
    throw err;
  }
}
